import React, { useState } from "react";
import { Checkbox, Radio, RadioChangeEvent, Rate, Space } from "antd";
import { Button, Container } from "react-bootstrap";
import { AiOutlineShoppingCart } from "react-icons/ai";
import { CiHeart } from "react-icons/ci";
import { GoShareAndroid } from "react-icons/go";
import { IoSearchOutline } from "react-icons/io5";
import { IoIosArrowUp } from "react-icons/io";
import LaptopDesc from "./LaptopDesc";
import { Link } from "react-router-dom";

const LaptopDetails = () => {
  const [value, setValue] = useState(1);
  const [startIndex, setStartIndex] = useState(0);
  const [currentIndex, setcurrentIndex] = useState(0);
  const visibleImagesCount = 3;

  const onChange = (e: RadioChangeEvent) => {
    console.log("radio checked", e.target.value);
    setValue(e.target.value);
  };

  const listArray = [
    "/assets/laptop.png",
    "/assets/proddeal.png",
    "/assets/laptop.png",
    "/assets/proddeal.png",
    "/assets/laptop.png",
  ];

  const handlenextvimg = () => {
    if (startIndex + visibleImagesCount < listArray.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handleprevimg = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const handleDisplayimage = (index: any) => {
    setcurrentIndex(index);
  };

  return (
    <>
      <section
        className="pb-4"
        style={{ paddingTop: "6rem", overflowX: "hidden" }}
      >
        <Container>
          <div>
            <p className="title-para">Home - Products-Laptop-HP</p>
            <h2 className="title-navhead">Products</h2>
          </div>
          <div className="row pt-4 pb-3">
            <div className="col-lg-1 col-md-3 col-sm-12 col-12">
              <div className="na-div">
                <div className="d-flex justify-content-center align-items-center">
                  <div className="upicons" onClick={handlenextvimg}>
                    <IoIosArrowUp />
                  </div>
                </div>
                <div className="map-div">
                  {listArray
                    .slice(startIndex, startIndex + visibleImagesCount)
                    .map((imgSrc, index) => {
                      const realIndex = startIndex + index; // Calculate the real index
                      return (
                        <div
                          className={`arr-div ${
                            currentIndex === realIndex ? "active-thumbnail" : ""
                          }`}
                          key={realIndex}
                          onClick={() => handleDisplayimage(realIndex)} // Pass the real index
                        >
                          <img src={imgSrc} className="img-fluid" />
                        </div>
                      );
                    })}
                </div>
                <div className="d-flex justify-content-center align-items-center">
                  <div className="downicons" onClick={handleprevimg}>
                    <IoIosArrowUp />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-9 col-sm-12 col-12 p-2">
              <div className="prod-con">
                <div className="">
                  <img
                    src={listArray[currentIndex]}
                    className="img-fluid proddeal-img mt-5"
                  />
                </div>
                <div className="deal-img">
                  <img className="img-fluid" src="/assets/deal.png" />
                </div>
                <div className="deal-imgicon">
                  <CiHeart className="me-2" style={{ cursor: "pointer" }} />
                  <GoShareAndroid style={{ cursor: "pointer" }} />
                </div>
              </div>
            </div>
            <div className="col-lg-7 col-md-7 col-sm-12 col-12 p-2">
              <div className="details-box">
                <div>
                  <h3>HP EliteBook 840 14.1In (14) Gen 13 laptop Silver</h3>
                  <Rate
                    disabled
                    defaultValue={2}
                    style={{ fontSize: "14px" }}
                  />
                  <span className="prod-rateing"> 4.0|5k Bought</span>
                  <p className="prod-id">
                    <span>
                      <strong>Product id :</strong>
                    </span>{" "}
                    45784{" "}
                    <span
                      className="px-2 py-1"
                      style={{
                        backgroundColor: "#2FB300",
                        borderRadius: "20px",
                        height: "15px",
                        width: "50px",
                        color: "#fff",
                        fontSize: "10px",
                      }}
                    >
                      In Stock
                    </span>
                  </p>
                  <p className="mb-0">
                    <span
                      className="me-2"
                      style={{
                        textDecoration: "line-through",
                        color: "#6C6C6C",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      ₹ 20,499.00
                    </span>
                    <span
                      style={{
                        color: "#2FB300",
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      Save 1,000 ( 10% Off )
                    </span>
                  </p>
                  <h2 className="price-single">
                    ₹ 19,499.00 <span>(Include all taxes)</span>
                  </h2>
                  <h3>Ram</h3>
                  <div className="py-2">
                    <Button className="ram-btn">4 GB</Button>
                  </div>
                  <h3>Storage</h3>
                  <div className="py-2">
                    <Button className="ram-btn">128 GB</Button>
                  </div>
                  <h3>Color</h3>
                  <div className="d-flex justify-content-start align-items-center py-2">
                    <div className="col-outer">
                      <div className="color"></div>
                      <span>Red</span>
                    </div>
                    <div className="col-outer">
                      <div className="color"></div>
                      <span>Red</span>
                    </div>
                  </div>

                  <h3>Enter your pincode</h3>
                  <div className="pin-code">
                    <input />
                    <Button>
                      <IoSearchOutline />
                    </Button>
                  </div>
                  <span className="del">Delivery by today</span>
                  <h3 className="pt-3">Delivery Type</h3>
                  <div>
                    <Radio.Group onChange={onChange} value={value}>
                      <Space direction="vertical">
                        <Radio value={1}>Standard Delivery</Radio>
                        <Radio value={2}>Express Delivery(₹ 100)</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <h3 className="pt-3">Exchange Type</h3>
                  <div>
                    <Radio.Group onChange={onChange} value={value}>
                      <Space direction="vertical">
                        <Radio value={1}>With Exchange</Radio>
                        <Radio value={2}>Without Exchange</Radio>
                      </Space>
                    </Radio.Group>
                  </div>
                  <h3 className="pt-3">Description</h3>
                  <table>
                    <tr>
                      <td className="td-desc">Brand</td>
                      <td className="td-descCon">: HP</td>
                    </tr>
                    <tr>
                      <td className="td-desc">Model</td>
                      <td className="td-descCon">: EliteBook </td>
                    </tr>
                    <tr>
                      <td className="td-desc">Screen Size</td>
                      <td className="td-descCon">: 12.1inch</td>
                    </tr>
                    <tr>
                      <td className="td-desc">ROM</td>
                      <td className="td-descCon">: 512GB</td>
                    </tr>
                    <tr>
                      <td className="td-desc">RAM</td>
                      <td className="td-descCon">: 16GB</td>
                    </tr>
                    <tr>
                      <td className="td-desc">OS</td>
                      <td className="td-descCon">: Windows 11 Pro</td>
                    </tr>
                  </table>
                  <div className="img-divs">
                    <div>
                      <img className="img-fluid" src="/assets/Group 1343.png" />
                    </div>
                    <div>
                      <img className="img-fluid" src="/assets/Group 1344.png" />
                    </div>
                    <div>
                      <img className="img-fluid" src="/assets/Group 1345.png" />
                    </div>
                    <div>
                      <img className="img-fluid" src="/assets/Group 1346.png" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
       
        </Container>
      </section>
      <section className="single-prodcart">
        <Container>
        <div className="">
            <div className="row">
              <div className="col-lg-1 col-md-1 col-sm-2 col-2"><div>
                <img className="img-fluid" src="/assets/phone 1.png" style={{width:"84px",height:"100px",objectFit:"contain",maxWidth:"85px"}}/>
                </div></div>
                   <div className="col-lg-7 col-md-7 col-sm-10 col-10"><div>
                    <h2 className="price-single">Samsung Galaxy A15 5G (8G , 256 GB , Black )</h2>
                    <p className="mb-0">
                    <span
                      className="me-2"
                      style={{
                        textDecoration: "line-through",
                        color: "#6C6C6C",
                        fontSize: "12px",
                        fontWeight: 400,
                      }}
                    >
                      ₹ 20,499.00
                    </span>
                    <span
                      style={{
                        color: "#2FB300",
                        fontSize: "14px",
                        fontWeight: 400,
                      }}
                    >
                      Save 1,000 ( 10% Off )
                    </span>
                  </p>
                  <h2 className="price-single">
                    ₹ 19,499.00 <span>(Include all taxes)</span>
                  </h2>
                    </div></div>
                   <div className="col-lg-4 col-md-4 col-sm-12 col-12"><div className="sing-para">
                    <p><img className="img-fluid" style={{width:"20px"}} src="/assets/fire.png"/>Limited stock available</p>
                    <Link to="/buy-together"><Button>Continue</Button></Link>
                    <Button>Add to Cart</Button>
                    </div></div>   
            </div>
          </div>
        </Container>
      </section>

      <LaptopDesc />
    </>
  );
};

export default LaptopDetails;
